import { Radio as NextRadio } from '@nextui-org/react';
import styled from 'styled-components';

import { ThemeProp } from '../../theme/Themes';

const RadioGroup = styled(NextRadio.Group)`
  .nextui-radio-label {
    border-width: 1.8px;
    &.nextui-radio--unchecked {
      .nextui-radio-point {
        border-color: ${({ theme }: ThemeProp) => theme.colors.neutrals.c200};
        &::after {
          border-color: ${({ theme }: ThemeProp) => theme.colors.neutrals.c200};
        }
      }
    }

    &.nextui-radio--checked {
      &:not(.nextui-radio--is-disabled) {
        .nextui-radio-point {
          border-color: ${({ theme }: ThemeProp) => theme.colors.neutrals.c600};
          &::after {
            border-color: ${({ theme }: ThemeProp) => theme.colors.main.c600};
          }
        }
      }
    }

    @media (min-width: ${(props: ThemeProp) => props.theme.breakpoints.mobile}) {
      &:not(.nextui-radio--is-disabled) {
        &:hover {
          .nextui-radio-point {
            background: ${({ theme }: ThemeProp) => theme.colors.content.white};

            &::after {
              border-color: ${({ theme }: ThemeProp) => theme.colors.main.c200};
            }
          }
        }
      }
    }
  }
`;

delete NextRadio.Group;

export const Radio = styled(NextRadio).attrs((props) => ({
  ...props,
  size: props.size || 'sm',
  css: {
    flexDirection: 'row',
    alignItems: 'center',
    flex: 1,
    '& .nextui-radio-container': {
      width: '100%',
      alignItems: 'center',
      height: '$9',
      justifyContent: 'space-between',
    },
    '& .nextui-radio-description': {
      'line-height': '$base2',
    },
    '& .nextui-radio-label': {
      flex: 1,
    },
    '& .nextui-radio-point': {
      margin: 0,
    },
  },
  ...props.css,
}))``;

// NOTE: This seems to cause some bugs with hot reloading in storybook.
Radio.Group = RadioGroup;

export const RadioForGrid = styled(Radio).attrs((props) => ({
  ...props,
  css: {
    marginTop: '0px !important',
    '& .nextui-radio-container': {
      width: '100%',
      alignItems: 'center',
      display: 'flex',
    },
    '& .nextui-radio-text': {
      flex: 1,
      overflow: 'hidden',
      width: 'auto',
    },
    '& .nextui-radio-point': {
      minWidth: '1rem',
    },
  },
}))``;
